import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { toast } from "react-toastify";
import axios from "../../components/Hooks/axios";
import { setUserObject } from "../../redux/slices/authSlice";
import styles from "./Privacy.module.scss";

export const LivePrivacy = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const [Everyone, setEveryone] = useState(true);
	const [PeopleFollow, setPeopleFollow] = useState(false);
	const [NoOne, setNoOne] = useState(false);
	const [disableSwitch, setDisableSwitch] = useState(false);

	useEffect(() => {
		if (user === null) return;
		setEveryone(user?.live_privacy?.everyone);
		setPeopleFollow(user?.live_privacy?.followers);
		setNoOne(user?.live_privacy?.no_one);
	}, [user]);

	const handelSwitchBtn = (e, content) => {
		setDisableSwitch(true);
		let ev = Everyone;
		let pf = PeopleFollow;
		let no = NoOne;

		if (content === "Everyone") {
			if (Everyone) return setDisableSwitch(false);
			ev = e;
			pf = false;
			no = false;
		}
		if (content === "PeopleFollow") {
			if (PeopleFollow) return setDisableSwitch(false);
			ev = false;
			pf = e;
			no = false;
		}
		if (content === "NoOne") {
			if (NoOne) return setDisableSwitch(false);
			ev = false;
			pf = false;
			no = e;
		}

		const id = toast.loading("Please Wait..");

		setEveryone(ev);
		setPeopleFollow(pf);
		setNoOne(no);

		const raw = JSON.stringify({
			live_privacy: {
				everyone: ev,
				followers: pf,
				no_one: no,
			},
		});

		axios
			.post("/auth/change-live-privacy", raw, {
				headers: {
					"content-type": "application/json",
				},
			})
			.then(({ data }) => {
				setDisableSwitch(false);
				toast.update(id, {
					render: "Your Live Privacy Successfully Updated",
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				dispatch(setUserObject(data.data));
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<div className={styles.FameoX}>
			<h1>Live</h1>
			<h2>Hide your live's from</h2>
			<div className={styles.AllowCommentsBox}>
				<div>
					<p>Everyone</p>
				</div>
				<Switch
					onChange={(e) => handelSwitchBtn(e, "Everyone")}
					checked={Everyone}
					disabled={disableSwitch}
					offColor={"#c4c4c4"}
					onColor={"#EFEFEF"}
					// offHandleColor={""}
					onHandleColor={"#A6539D"}
					uncheckedIcon={false}
					checkedIcon={false}
					activeBoxShadow={"0 0 0px 0px #909AFF"}
					height={19}
					width={46}
				/>
			</div>
			<div className={styles.AllowCommentsBox}>
				<div>
					<p>People you follow</p>
					<span>53 people</span>
				</div>
				<Switch
					onChange={(e) => handelSwitchBtn(e, "PeopleFollow")}
					checked={PeopleFollow}
					disabled={disableSwitch}
					offColor={"#c4c4c4"}
					onColor={"#EFEFEF"}
					// offHandleColor={""}
					onHandleColor={"#A6539D"}
					uncheckedIcon={false}
					checkedIcon={false}
					activeBoxShadow={"0 0 0px 0px #909AFF"}
					height={19}
					width={46}
				/>
			</div>
			<div className={styles.AllowCommentsBox}>
				<div>
					<p>No one</p>
				</div>
				<Switch
					onChange={(e) => handelSwitchBtn(e, "NoOne")}
					checked={NoOne}
					disabled={disableSwitch}
					offColor={"#c4c4c4"}
					onColor={"#EFEFEF"}
					// offHandleColor={""}
					onHandleColor={"#A6539D"}
					uncheckedIcon={false}
					checkedIcon={false}
					activeBoxShadow={"0 0 0px 0px #909AFF"}
					height={19}
					width={46}
				/>
			</div>
		</div>
	);
};


